<template>
    <ReplyOrForwardComponent/>
</template>

<script>
import ReplyOrForwardComponent from "../../components/ReplyOrForwardComponent.vue";
import SendStateEnum from "../../enums/SendStateEnum";

export default {
  name: "CustomerEmailPageSend.vue",
  components: {
    ReplyOrForwardComponent
  },
  props:{
    initialSendState: {
      validator(value) {
        return Object.values(SendStateEnum).includes(value);
      }
    }
  },
  async created() {
    await this.$store.dispatch('email/setSendState', this.initialSendState);
  }
}
</script>
